import ApiAuthConf from "../conf/api/ApiAuth.conf";
import tokenUrl from "@/utils/apiUrl/seguridad/token.url";
import axiosUrlcontext from "../conf/axios.urlcontext";
import interceptor from "../conf/httpinterceptor";
import CryptoJS from "crypto-js";
import httpErrorMessage from "@/utils/httpErrorMessage";

export default {
    async iniciarSesion(login,password) {
        try {

            /*Se agrega el valor de la url*/
            let apiAuth = ApiAuthConf.getConfiguration()
            apiAuth.url = tokenUrl.URL_TOKEN
            /*Se configura el body */
            let timestamp = Math.floor(Date.now() / 1000);

            const akey = axiosUrlcontext.APP_CLIENT_ID;
            const secretkey = axiosUrlcontext.APP_SECRET_KEY;
            const apasword = password;

            const sig = akey + secretkey + timestamp;

            const hash = CryptoJS.SHA256(sig).toString();
            const password_256= CryptoJS.SHA256(apasword).toString();

            const platform = navigator.userAgent


            apiAuth.body = {
                clientid: akey,
                secretkey: secretkey,
                timestamp: timestamp,
                signature: hash,
                grant_type: "password",
                device_ip: "10001",
                platform: platform,
                login: login,
                password: password_256,
                refresh_token: null
            }

            //*Ejemplo de response */
            // {
            //     "success": true,
            //     "status": 200,
            //     "statusText": "OK",
            //     "data": {
            //       "status": 200,
            //       "data": {
            //         "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZFVzdWFyaW8iOiIxMiIsIk5vbWJyZV9wYW50YWxsYSI6Ikp1YW4gVG9sZWRvIiwiRW1haWwiOiJ0b2xlZG9zb2xpcyIsIklkRW1wbGVhZG8iOiIwIiwiSWRSb2wiOiIxIiwiZXhwIjoxNjY2MjAyOTEzLCJpc3MiOiJ3d3cuaGFjaWVuZGFjaGlhcGFzLmdvYi5teCIsImF1ZCI6Ind3dy5oYWNpZW5kYWNoaWFwYXMuZ29iLm14In0.OzNBFMPmhK9mK82OZSaLMVai5N-iFb0NoLlQq0X0xdI",
            //         "token_type": "Bearer",
            //         "expire_in": 120,
            //         "refresh_token": "/6RClSXv8MX7bGUoO7RiJoGWpgu5oLRYGGOD7Zd81U3lNZzcTD545cBrY1Ylt2UxMcDi0R98nsE0mi0NPtq3/g=="
            //       },
            //       "message": "Process sucessfully"
            //     }
            //   }

            /*Se consume el metodo de acuerdo a lo rquerido (get,post,delete,put) */
            let response = await apiAuth.post()

            /*Muestra el error de la api */
            if(response.data && response.data.status != 200){
                throw new Error(response.data.message ? response.data.message : httpErrorMessage.DEFAULT_ERROR)
            /*Muetra el error de la libreria hcRequest */
            }else if(response.status != 200){
                throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            }

            /*Retorna el response*/
            return response.data
            
        } catch (error) {
           throw new Error(error.message)
        }
    },
    async obtenerRefreshToken(refreshToken){

        try {
            /*Se agrega el valor de la url*/
            let apiAuth = ApiAuthConf.getConfiguration()
            apiAuth.url = tokenUrl.URL_TOKEN
            /*Se configura el body */
            let timestamp = Math.floor(Date.now() / 1000);

            const akey = axiosUrlcontext.APP_CLIENT_ID;
            const secretkey = axiosUrlcontext.APP_SECRET_KEY;

            const sig = akey + secretkey + timestamp;

            const hash = CryptoJS.SHA256(sig).toString();

            const platform = navigator.userAgent

            apiAuth.body = {
                clientid: akey,
                secretkey: secretkey,
                timestamp: timestamp,
                signature: hash,
                grant_type: "refresh_token",
                device_ip: "10001",
                platform: platform,
                login: null,
                password: null,
                refresh_token: refreshToken
            }
            
            /*Se consume el metodo de acuerdo a lo rquerido (get,post,delete,put) */
            
            let response = await apiAuth.post()

            /*Muestra el error de la api */
            if(response.data && response.data.status != 200){
                throw new Error(response.data.message ? response.data.message : httpErrorMessage.DEFAULT_ERROR)
            /*Muetra el error de la libreria hcRequest */
            }else if(response.status != 200){
                throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            }
            /*Retorna el response*/
            return response.data
            
        } catch (error) {
           throw new Error(error.message)
        }
    },
    /*async obtenerUsuario(idsubsistema){
        try {            
            let apiAuth = ApiAuthConf.getConfiguration()
            apiAuth.url = tokenUrl.URL_PERFIL+`/${idsubsistema}`            
            
            apiAuth.instance = interceptor.getInterceptor(apiAuth.instance)
            
            let response = await apiAuth.get()


            if(response.data && response.data.status != 200){
                throw new Error(response.data.message ? response.data.message : httpErrorMessage.DEFAULT_ERROR)

            }else if(response.status != 200){
                throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            }
            
            return response.data
            
        } catch (error) {
           throw new Error(error.message)
        }
    },*/
    
    async obtenerUsuario(idsubsistema){
        try {            
            let apiAuth = ApiAuthConf.getConfiguration()            
            apiAuth.url = tokenUrl.URL_PERFIL+`/${idsubsistema}`                                  
            apiAuth.instance = interceptor.getInterceptor(apiAuth.instance)            
            let response = await apiAuth.get()            
            if(response.data && response.data.status != 200){
                throw new Error(response.data.message ? response.data.message : httpErrorMessage.DEFAULT_ERROR)
            
            }else if(response.status != 200){
                throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            }
            
            return response.data
            
        } catch (error) {
           throw new Error(error.message)
        }
    },
    //URL_MODULOS
    
    async client_credentials() {
        try {
            /*Se agrega el valor de la url*/
            let apiAuth = ApiAuthConf.getConfiguration()
            apiAuth.url = tokenUrl.URL_TOKEN
            /*Se configura el body */
            let timestamp = Math.floor(Date.now() / 1000);
            const akey = axiosUrlcontext.APP_CLIENT_ID;
            const secretkey = axiosUrlcontext.APP_SECRET_KEY;
            const sig = akey + secretkey + timestamp;
            const hash = CryptoJS.SHA256(sig).toString();

            apiAuth.body = {
                clientid: akey,
                secretkey: secretkey,
                timestamp: timestamp,
                signature: hash,
                grant_type: "client_credentials",
                device_ip: null,
                platform: null,
                refresh_token: null
            }
            /*Se consume el metodo de acuerdo a lo rquerido (get,post,delete,put) */
            let response = await apiAuth.post();
            return response.data

            /*Muestra el error de la api */
            if(response.data && response.data.status != 200){
                throw new Error(response.data.message ? response.data.message : httpErrorMessage.DEFAULT_ERROR)
            /*Muetra el error de la libreria hcRequest */
            }else if(response.status != 200){
                throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            }

            /*Retorna el response*/
            return response.data
            
        } catch (error) {
           throw new Error(error.message)
        }
    },
}